<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> USI </h3>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createUsi">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" data-bs-toggle="modal" data-bs-target="#deleteUsi" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createUsi" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                       style="height: calc(100vh - 120px) !important;" 
                         class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>




<!-- Delete an item -->
<div class="modal fade" id="deleteUsi" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteLead" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteUsiList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 


<!-- Create new Lead -->
<div class="modal fade bd-example-modal-lg" id="createUsi" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="usiForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create USI</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="id" type="text" required>
                                    <label for="id" class="floating-label">ID</label>
                                    <i class="ri-shield-user-line"></i>
                                </div>
                                <mat-error *ngIf="f.id.invalid && (f.id.dirty ||f.id.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.id.errors.required">
                                       Id is required
                                    </mat-error>
                                  </mat-error>  
                            </div>
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="title" type="text" >
                                    <label for="title" class="floating-label">Title</label>
                                    <i class="ri-building-line"></i>
                                </div>
                            </div>
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="version" type="text" >
                                    <label for="version" class="floating-label">Version</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">                            
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="issue" type="text" required>
                                    <label for="issue" class="floating-label">Issue</label>
                                    <i class="ri-user-line"></i>
                                </div>
                                <mat-error *ngIf="f.issue.invalid && (f.issue.dirty ||f.issue.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.issue.errors.required">
                                       Issue is required
                                    </mat-error>
                                </mat-error>
                            </div>
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="model" type="text" required>
                                    <label for="model" class="floating-label">Model</label>
                                    <i class="ri-text"></i>
                                </div>
                                <mat-error *ngIf="f.model.invalid && (f.model.dirty ||f.model.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.model.errors.required">
                                       Model is required
                                    </mat-error>
                                </mat-error> 
                            </div> 
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="buildPhase" type="text" >
                                    <label for="buildPhase "class="floating-label">Build Phase</label>
                                    <i class="ri-mail-unread-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="sopset" type="text" >
                                    <label for="sopset" class="floating-label">Sop Set</label>
                                    <i class="ri-device-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="riskA">
                                        <option value="Risk A">Risk A</option>
                                        <option value="Risk B">Risk B</option>
                                        <option value="Risk C">Risk C</option>
                                        <option value="Risk D">Risk D</option>
                                    </select>
                                    <label for="riskA" class="floating-label floating-label-special">Select Risk</label>
                                    <i class="ri-printer-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="workshopInstructions" type="text" >
                                    <label for="workshopInstructions" class="floating-label">Workshop Instructions</label>
                                    <i class="ri-earth-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="problemDescription" type="text" >
                                    <label for="problemDescription" class="floating-label">Problem Description</label>
                                    <i class="ri-line-chart-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="recommendations" type="text" >
                                    <label for="recommendations" class="floating-label">Recommendations</label>
                                    <i class="ri-24-hours-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="affectedVehicles" type="text" >
                                    <label for="affectedVehicles" class="floating-label">Affected Vehicles</label>
                                    <i class="ri-building-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="requiredActions" type="text" >
                                    <label for="requiredActions" class="floating-label">Required Actions</label>
                                    <i class="ri-building-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="timeRequiredForUpgradeInHours" type="text" >
                                    <label for="timeRequiredForUpgradeInHours" class="floating-label">Time Required For Upgrade In Hours</label>
                                    <i class="ri-money-dollar-circle-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contactPerson" type="text" >
                                    <label for="contactPerson" class="floating-label">Contact Person</label>
                                    <i class="ri-star-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contactDepartmentCode" type="text" >
                                    <label for="contactDepartmentCode" class="floating-label">Contact Department Code</label>
                                    <i class="ri-skype-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contactPhoneNo" type="text" >
                                    <label for="contactPhoneNo" class="floating-label">Contact PhoneNo</label>
                                    <i class="ri-phone-line"></i>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input formControlName="contactEmailAddress" type="text" >
                                    <label for="contactEmailAddress" class="floating-label">Contact Email Address</label>
                                    <i class="ri-mail-unread-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createUSI()" [disabled]="!usiForm.valid?true:null" >Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateusi()" [disabled]="!usiForm.valid?true:null" >Update</button>
                </div>
            </form>
        </div>
    </div>
</div>